<template>
  <div class="aiTool">
    <div class="Tool_item" v-for="(item,index) in toolList">
      <div class="item_title" :class="index!=0?'margin_t':''">{{ item.title }}</div>
      <div class="list">
        <div v-for="(list,index) in item.list" @click="jumpChild(list,index)" class="item">
          <div class="item_box">
              <img alt="" class="item_img" :src="list.img">
              <h3 class="item_h">{{list.name }}</h3>
              <p class="item_p">{{list.guide}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      toolList: [

        {
          title: 'AI变美',id:4 , list: [
            {
              id: 1,
              relation: 3,
              name: '照片一键美颜',
              mj_tool: 'oneClickBeautyTransformation',
              guide: '利用AI技术，实现完整的肖像增强，包括皮肤平滑、美白、脸部瘦身等，以达到自然的外观',
              img: require('../components/img/side/beautify1.webp'),
              points: 1,
            },
            {
              id: 2,
              relation: 3,
              name: '人物动漫化',
              mj_tool: 'characterAnime',
              guide: '利用先进的AI技术将完整图像或照片转化为卡通或动漫效果，非常适合创建卡通化照片和卡通风格的虚拟形象',
              img: require('../components/img/side/beautify2.webp'),
              points: 1,
            },
            {
              id: 3,
              relation: 3,
              name: '人脸滤镜',
              mj_tool: 'emitFacefilter',
              guide: '智能识别图像内容，快速应用AI滤镜，提升图像质感，支持滤镜强度调节，轻松优化视觉效果',
              img: require('../components/img/side/beautify3.webp'),
              points: 1,
            },
            {
              id: 4,
              relation: 3,
              name: '人脸模糊(打码)',
              mj_tool: 'emitBlurredfaces',
              guide: '利用先进的AI技术，智能识别人脸区域，一键模糊人脸，轻松保护隐私，提升图像安全性',
              img: require('../components/img/side/beautify4.webp'),
              points: 1,
            },
            {
              id: 5,
              relation: 3,
              name: '发型编辑',
              mj_tool: 'emitHairstyleeditor',
              guide: '能够精准识别人像区域，实现一键更换发型和发色。您可以选择多达数十种发型和发色组合，轻松打造您独特的个性化造型，满足不同的美发需求',
              img: require('../components/img/side/beautify5.webp'),
              points: 1,
            },
            {
              id: 6,
              relation: 3,
              name: '表情编辑',
              mj_tool: 'emitEmotioneditor',
              guide: '无论是闭嘴微笑、露齿笑、嘟嘴、还是耍酷或悲伤等十多种表情，您都可以轻松生成自然逼真的效果',
              img: require('../components/img/side/beautify6.webp'),
              points: 1,
            },
            {
              id: 7,
              relation: 3,
              name: '年龄・性別变换',
              mj_tool: 'emitFaceattributeediting',
              guide: '采用先进的AI技术，智能识别人脸，实现从15岁到85岁的年龄变换，以及男性与女性之间的性别转换',
              img: require('../components/img/side/beautify7.webp'),
              points: 1,
            },
            // {
            //   id: 8,
            //   relation: 3,
            //   name: '人脸美颜',
            //   mj_tool: 'emitFacebeauty',
            //   guide: '拥有美白和光滑皮肤等美化特性，以及面部塑形。此外，它还提供了多种滤镜，以增强您的图像并增添艺术气息。',
            //   img: require('../components/img/side/beautify8.webp'),
            //   points: 1,
            // },
            {
              id: 9,
              relation: 3,
              name: '人脸美妆',
              mj_tool: 'emitFacemakeup',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('../components/img/side/beautify9.webp'),
              points: 1,
            },
            {
              id: 10,
              relation: 3,
              name: '唇色变换器',
              mj_tool: 'emitLipscolorchanger',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('../components/img/side/beautify10.webp'),
              points: 1,
            },
            {
              id: 11,
              relation: 3,
              name: '人脸修复增强',
              mj_tool: 'emitEnhanceface',
              guide: '自动去除图像中的模糊部分，提升脸部的清晰度和细节。通过AI处理，您可以轻松优化面部图像的质量，使其更加清晰、自然',
              img: require('../components/img/side/beautify11.webp'),
              points: 1,
            },
          ],
        },

      ],
    }
  },
  methods: {
    jumpChild(list, index) {
      console.log(list.name)
      console.log(index)
      console.log('跳转子集')
      // return

        this.$router.push({
          path: '/workflow',
          query: {
            // linkTo:list.id,
            arrange: list.id,
            relation: list.relation,
          }
        });

    },
  }
}
</script>
<style scoped lang="scss">
.aiTool {
  padding: 20px 20px;
  overflow-y: auto;
  height: 100%;

  .Tool_item {
    .item_title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 20px;
      color: #fff;
      //margin-top: 20px;
      span {
        font-size: 12px;
        font-weight: 400;
      }

    }
    .margin_t{
      margin-top: 20px;
    }

    // 排除第一个的样式


    .list {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 24px;
      .item {

        transition: box-shadow .2s ease;
        border-radius: 10px;
        width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor:pointer;
        .item_box{
          border-radius: inherit;
          margin-left: auto;
          margin-right: auto;
          height: 100%;
          width: 100%;
          display: block;
          position: relative;
          overflow: hidden;
          background-color: #eee;

          .item_img{
            transition: transform .2s ease;
            aspect-ratio: auto 16 / 9;
            width: 100%;
            vertical-align: middle;
            object-fit: cover;
            -webkit-user-drag: none;
          }
          .item_h{
            font-weight: 700;
            font-size: 18px;
            margin: 10px 16px 0;
            min-height: 2em;
            display: flex;
            align-items: center;
            color: #666;
          }
          .item_p{
            color: #646464;
            margin:0px 16px 15px;
            font-size: 14px;
          }
        }
      }
      .item:hover {
        box-shadow:0px 0px 20px 0px #424242; /* 阴影效果 */
        .item_img{
          transform: scale(1.05); /* 放大图片 */
        }
      }



    }
  }
}

@media (max-width: 1299px) {
  .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr) !important;
    grid-gap: 24px;
  }
}
@media (max-width: 875px) {
  .list {
    display: grid;
    grid-template-columns: repeat(2, 1fr) !important;
    grid-gap: 24px;
  }
}

</style>